import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getClinicGeneralServiceMasterByClinicId } from "../../../../store/slices/clinicGeneralServiceMaster";
import Select from "react-select";

const General = ({ handleChange, isClient }) => {
  const [selectedGeneralServices, setSelectedGeneralServices] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const dispatch = useDispatch();
  const { clinicGeneralServiceMasterByClinicId } = useSelector(
    (state) => state.clinicGeneralServiceMaster
  );
  const { token } = useSelector((state) => state.auth);
const clinicId = clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(
      getClinicGeneralServiceMasterByClinicId({
        clinicId,
        token,
      })
    );
  }, [dispatch, clinicId, token]);

  const handleSelectedGeneralService = (selectedOptions) => {
    setSelectedGeneralServices(selectedOptions || []);
    handleChange(
      (selectedOptions || []).map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  };

  useEffect(() => {
    if (!selectedGeneralServices.length) return;

    const updatedServices = selectedGeneralServices.map((option) => {
      const servicePrice =
        clinicGeneralServiceMasterByClinicId?.[0]?.services?.find(
          (serv) => serv._id === option.value
        );

      return {
        ...option,
        price:
          isClient === "Yes"
            ? servicePrice?.client_price
            : servicePrice?.pt_price,
      };
    });

    setSelectedGeneralServices(updatedServices);

    handleChange(
      updatedServices.map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  }, [isClient]);

  useEffect(() => {
    const totalAmount = selectedGeneralServices?.reduce((sum, option) => {
      return sum + (option.price || 0);
    }, 0);

    setTotalAmount(totalAmount);
  }, [selectedGeneralServices]);

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={clinicGeneralServiceMasterByClinicId?.[0]?.services
              ?.filter((servicedetails) => servicedetails.status === "Active")
              ?.map((servicedetails) => ({
                value: servicedetails?._id,
                label: servicedetails?.serviceDetailName,
                type: "general",
                price: isClient === "Yes" ? servicedetails?.client_price : servicedetails?.pt_price,
              }))}
              value={selectedGeneralServices}
            onChange={handleSelectedGeneralService}
            isMulti
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="total-amount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="total-amount"
            value={totalAmount}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default General;
